module.exports = __webpack_public_path__ + "img/38_79.76128214.png";